import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import Sidebar from "./Sidebar";
import Header from "./Header";
import DashboardFooter from "./DashboardFooter";
import "../css/Staff.css";
import "bootstrap/dist/css/bootstrap.min.css";
import {
  FaEdit,
  FaTrash,
  FaEye,
  FaDownload,
  FaPlus,
  FaImage,
  FaSync,
  FaSearch,
  FaTimes,
  FaFilter,
  FaTable,
  FaColumns
} from "react-icons/fa";
import * as XLSX from "xlsx";

const API_URL = "https://auxititpt.org/Backend/staff_api.php";
const TRADE_API_URL = "https://auxititpt.org/Backend/trade_api.php";

const Staff = () => {
  const [staffList, setStaffList] = useState([]);
  const [tradeList, setTradeList] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showForm, setShowForm] = useState(false);
  const [showViewModal, setShowViewModal] = useState(false);
  const [selectedStaff, setSelectedStaff] = useState(null);
  const [editStaff, setEditStaff] = useState(null);
  const [showAllColumns, setShowAllColumns] = useState(false); // New state for view toggle


  // search & filter (applied)
  const [searchQuery, setSearchQuery] = useState("");
  const [filterTrades, setFilterTrades] = useState([]); // array of trade_name
  const [filterDesignations, setFilterDesignations] = useState([]); // array of designation

  // modal temp selections
  const [showFilterModal, setShowFilterModal] = useState(false);
  const [tempTrades, setTempTrades] = useState([]);
  const [tempDesignations, setTempDesignations] = useState([]);

  const initialFormData = {
    name: "",
    designation: "",
    trade: "",
    qualification: "",
    date_of_joining: "",
    address: "",
    mobile_number: "",
    email_id: "",
    blood_group: "",
    date_of_birth: "",
    status: "active",
    staff_photo: null,
  };

  const [formData, setFormData] = useState(initialFormData);

  useEffect(() => {
    fetchAll();
  }, []);

  const fetchAll = async () => {
    setLoading(true);
    await Promise.all([fetchStaff(), fetchTrades()]);
    setLoading(false);
  };

  const fetchStaff = async () => {
    try {
      const res = await fetch(API_URL);
      if (!res.ok) throw new Error(`HTTP ${res.status}`);
      const data = await res.json();
      setStaffList(Array.isArray(data) ? data : []);
    } catch (err) {
      console.error("Fetch staff error:", err);
      alert("Failed to load staff data. Check console.");
    }
  };

  const fetchTrades = async () => {
    try {
      const res = await fetch(TRADE_API_URL);
      if (!res.ok) throw new Error(`Trade API HTTP ${res.status}`);
      const data = await res.json();
      const arr = Array.isArray(data) ? data : [];

      const sorted = [...arr].sort((a, b) => {
        const aTime = a.created_at ? new Date(a.created_at).getTime() : 0;
        const bTime = b.created_at ? new Date(b.created_at).getTime() : 0;
        return aTime - bTime;
      });

      setTradeList(sorted);
    } catch (err) {
      console.error("Fetch trade error:", err);
      setTradeList([]);
    }
  };

  const handleChange = (e) => {
    const { name, value, files, type } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: type === "file" ? files[0] : value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const url = editStaff ? `${API_URL}?id=${editStaff.staff_id}` : API_URL;

    const formDataToSend = new FormData();
    for (const key in formData) {
      if (formData[key] !== null && formData[key] !== "") {
        formDataToSend.append(key, formData[key]);
      }
    }

    try {
      const response = await fetch(url, { method: "POST", body: formDataToSend });
      const text = await response.text();
      let result;

      try {
        result = JSON.parse(text);
      } catch {
        throw new Error("Server returned invalid response");
      }

      if (response.ok && result.status === "success") {
        alert(editStaff ? "Staff updated!" : "Staff added!");
        await fetchStaff();
        resetForm();
      } else {
        throw new Error(result.message || "Operation failed");
      }
    } catch (err) {
      console.error("Submit error:", err);
      alert("Error: " + err.message);
    }
  };

  const resetForm = () => {
    setFormData(initialFormData);
    setEditStaff(null);
    setShowForm(false);
  };

  const openAddForm = async () => {
    await fetchTrades();
    setFormData(initialFormData);
    setEditStaff(null);
    setShowForm(true);
  };

  const handleView = async (staff) => {
    try {
      const res = await fetch(`${API_URL}?id=${staff.staff_id}`);
      if (!res.ok) throw new Error(`HTTP ${res.status}`);
      const fullStaff = await res.json();
      setSelectedStaff(fullStaff);
      setShowViewModal(true);
    } catch (err) {
      console.error("View fetch error:", err);
      alert("Failed to load staff details");
    }
  };

  const handleEdit = async (staff) => {
    await fetchTrades();

    setFormData({
      name: staff.name || "",
      designation: staff.designation || "",
      trade: staff.trade || "",
      qualification: staff.qualification || "",
      date_of_joining: staff.date_of_joining || "",
      address: staff.address || "",
      mobile_number: staff.mobile_number || "",
      email_id: staff.email_id || "",
      blood_group: staff.blood_group || "",
      date_of_birth: staff.date_of_birth || "",
      status: staff.status || "active",
      staff_photo: null,
    });
    setEditStaff(staff);
    setShowForm(true);
  };

  const handleDelete = async (id) => {
    if (!window.confirm("Deactivate this staff member? They will no longer appear in public views.")) return;
    try {
      const res = await fetch(`${API_URL}?id=${id}`, { method: "DELETE" });
      const result = await res.json();
      if (res.ok && result.status === "success") {
        alert("Staff deactivated!");
        await fetchStaff();
      } else {
        throw new Error(result.message || "Deactivation failed");
      }
    } catch (err) {
      console.error("Delete error:", err);
      alert("Error: " + err.message);
    }
  };

  // ------------------------------
  // EXPORT: EXCEL – ONLY FILTERED DATA
  // ------------------------------
  const exportToExcel = () => {
    // Use filteredStaff (already includes search + all filters)
    const dataToExport = filteredStaff;

    if (!dataToExport || dataToExport.length === 0) {
      alert("No staff data to export (filtered results are empty)");
      return;
    }

    // Map filtered data to include all fields with proper formatting
    const exportData = dataToExport.map(staff => ({
      'Name': staff.name || "",
      'Designation': staff.designation || "",
      'Trade': staff.trade || "",
      'Qualification': staff.qualification || "",
      'Date of Joining': staff.date_of_joining || "",
      'Date of Birth': staff.date_of_birth || "",
      'Blood Group': staff.blood_group || "",
      'Address': staff.address || "",
      'Mobile Number': staff.mobile_number || "",
      'Email ID': staff.email_id || "",
      'Status': staff.status === 'active' ? 'Active' : 'Inactive',
      'Photo URL': staff.staff_photo_url ? `https://localhost${staff.staff_photo_url}` : "",
    }));

    // Convert JSON → Excel worksheet
    const worksheet = XLSX.utils.json_to_sheet(exportData);

    // Create workbook
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Staff");

    // Apply column width adjustments
    const wscols = [
      { wch: 20 }, // Name
      { wch: 20 }, // Designation
      { wch: 15 }, // Trade
      { wch: 20 }, // Qualification
      { wch: 15 }, // DOJ
      { wch: 15 }, // DOB
      { wch: 12 }, // Blood Group
      { wch: 30 }, // Address
      { wch: 15 }, // Mobile
      { wch: 25 }, // Email
      { wch: 12 }, // Status
      { wch: 30 }  // Photo URL
    ];
    worksheet['!cols'] = wscols;

    // Smart filename: add "_Filtered" if any filter/search is active
    const isFiltered = activeFilterCount() > 0 || searchQuery.trim();
    const filterTag = isFiltered ? "_Filtered" : "";
    const today = new Date().toISOString().split('T')[0];
    const filename = `Staff_Details${filterTag}_${today}.xlsx`;

    // Export
    XLSX.writeFile(workbook, filename);
  };

  const LETTERHEAD_IMAGE = "https://auxititpt.org/public/uploads/Letter_Head_Axilium_English.jpg";

  const fixUrl = (url) => {
    if (!url) return null;
    if (url.startsWith("https")) return url;
    const clean = url.startsWith("/") ? url : "/" + url;
    return `https://localhost${clean}`;
  };

  const handlePrintForStaff = (staff) => {
    const formattedDOB = staff.date_of_birth
      ? new Date(staff.date_of_birth).toLocaleDateString("en-GB")
      : "—";
    const formattedDOJ = staff.date_of_joining
      ? new Date(staff.date_of_joining).toLocaleDateString("en-GB")
      : "—";

    const popup = window.open("", "_blank", "width=900,height=1000,scrollbars=no,resizable=yes");

    popup.document.write(`
<!DOCTYPE html>
<html lang="en">
<head>
  <meta charset="UTF-8">
  <title>Staff Details - ${staff.name || "N/A"}</title>
  <style>
    @page { size: A4; margin: 0; }
    html, body { margin:0; padding:0; height:297mm; overflow:hidden; }
    body {
      font-family: 'Poppins', sans-serif;
      position: relative;
      font-size: 0.95rem;
      line-height: 1.4;
    }

    /* Letterhead Background */
    body::before {
      content: '';
      position: fixed;
      top: 0; left: 0;
      width: 210mm; height: 297mm;
      background: url('${LETTERHEAD_IMAGE}') no-repeat top center / 100% auto;
      z-index: -1;
      -webkit-print-color-adjust: exact !important;
      color-adjust: exact !important;
    }

    /* Content starts after letterhead */
    .content {
      padding: 60mm 8mm 8mm 8mm;
      position: relative;
      z-index: 1;
    }

    .title {
      text-align: center;
      text-decoration: underline;
      font-size: 1.35rem;
      margin: 0 0 6px;
    }

    /* Header Table: Photo + Name */
    .header-table {
      width: 100%;
      border-collapse: collapse;
      margin: 4px 0 10px 0;
    }
    .header-table td {
      border: none !important;
      padding: 2px 0;
      vertical-align: top;
    }
    .photo-cell { width: 55%; }
    .name-cell { width: 45%; text-align: right; }
    .staff-name {
      font-weight: bold;
      font-size: 1.15rem;
      margin: 0;
    }

    /* Main Details Table */
    .details-table {
      width: 100%;
      border-collapse: collapse;
      margin: 6px 0;
    }
    .details-table td {
      padding: 3px 4px;
      border: 1px solid #000 !important;
      font-size: 0.92rem;
    }

    .photo-section {
      margin: 3px 0;
    }
    .staff-photo {
      max-width: 85px;
      max-height: 85px;
      border: 1px solid #ccc;
      display: inline-block;
    }

    .signature {
      margin-top: 25px;
      text-align: right;
      font-weight: bold;
      font-size: 1rem;
    }

    @media print {
      body::before, .details-table td {
        -webkit-print-color-adjust: exact !important;
        color-adjust: exact !important;
      }
    }
  </style>
</head>
<body>
  <div class="content">
    <div class="title">Staff Details</div>

    <!-- Header: Photo + Name -->
    <table class="header-table">
      <tr>
        <td class="photo-cell">
          ${staff.staff_photo_url ? `
          <div class="photo-section">
            <strong>Staff Photo:</strong><br>
            <img src="${fixUrl(staff.staff_photo_url)}" class="staff-photo" alt="Photo">
          </div>` : ''}
        </td>
        <td class="name-cell">
          <div class="staff-name">${staff.name || "N/A"}</div>
        </td>
      </tr>
    </table>

    <!-- Main Details Table -->
    <table class="details-table">
      <tr><td><strong>Designation</strong></td><td>${staff.designation}</td></tr>
      <tr><td><strong>Trade</strong></td><td>${staff.trade || "—"}</td></tr>
      <tr><td><strong>Qualification</strong></td><td>${staff.qualification || "—"}</td></tr>
      <tr><td><strong>Date of Joining</strong></td><td>${formattedDOJ}</td></tr>
      <tr><td><strong>Date of Birth</strong></td><td>${formattedDOB}</td></tr>
      <tr><td><strong>Blood Group</strong></td><td>${staff.blood_group || "—"}</td></tr>
      <tr><td><strong>Address</strong></td><td>${staff.address}</td></tr>
      <tr><td><strong>Mobile No</strong></td><td>${staff.mobile_number}</td></tr>
      <tr><td><strong>Email ID</strong></td><td>${staff.email_id}</td></tr>
      <tr><td><strong>Status</strong></td><td>${staff.status === 'active' ? 'Active' : 'Inactive'}</td></tr>
    </table>

    <!-- Principal Signature -->
    <div class="signature">Principal Signature</div>
  </div>

  <script>
    window.onload = () => setTimeout(() => window.print(), 300);
    window.onafterprint = () => window.close();
    const mq = window.matchMedia('print');
    mq.addEventListener('change', (m) => { if (!m.matches) setTimeout(() => window.close(), 100); });
  </script>
</body>
</html>
  `);

    popup.document.close();
    popup.focus();
  };

  const getPhotoUrl = (url) => {
    if (!url) return null;
    if (url.startsWith("https")) return url;
    return `https://localhost${url}`;
  };

  // Dynamic unique designations
  const uniqueDesignations = Array.from(
    new Set(staffList.map((s) => (s.designation || "").trim()).filter(Boolean))
  );

  const uniqueTrades = tradeList.map((t) => t.trade_name);

  // Define columns for the table based on view mode
  const tableColumns = showAllColumns ? [
    { header: '#', accessor: 'index' },
    { header: 'Name', accessor: 'name' },
    { header: 'Designation', accessor: 'designation' },
    { header: 'Trade', accessor: 'trade' },
    { header: 'Qualification', accessor: 'qualification' },
    { header: 'Date of Joining', accessor: 'date_of_joining' },
    { header: 'Date of Birth', accessor: 'date_of_birth' },
    { header: 'Blood Group', accessor: 'blood_group' },
    { header: 'Address', accessor: 'address' },
    { header: 'Mobile', accessor: 'mobile_number' },
    { header: 'Email', accessor: 'email_id' },
    { header: 'Status', accessor: 'status' },
    { header: 'Photo', accessor: 'staff_photo_url' },
    { header: 'Actions', accessor: 'actions' }
  ] : [
    { header: '#', accessor: 'index' },
    { header: 'Name', accessor: 'name' },
    { header: 'Designation', accessor: 'designation' },
    { header: 'Trade', accessor: 'trade' },
    { header: 'Mobile', accessor: 'mobile_number' },
    { header: 'Email', accessor: 'email_id' },
    { header: 'Actions', accessor: 'actions' }
  ];

  // helper toggle for temp arrays
  const toggleTemp = (value, arr, setArr) => {
    if (arr.includes(value)) setArr(arr.filter((a) => a !== value));
    else setArr([...arr, value]);
  };

  // open filter modal: seed temp arrays with applied filters
  const openFilterModal = () => {
    setTempTrades([...filterTrades]);
    setTempDesignations([...filterDesignations]);
    setShowFilterModal(true);
  };

  const applyFiltersFromModal = () => {
    setFilterTrades([...tempTrades]);
    setFilterDesignations([...tempDesignations]);
    setShowFilterModal(false);
  };

  const clearModalSelections = () => {
    setTempTrades([]);
    setTempDesignations([]);
  };

  const clearAllFilters = () => {
    setFilterTrades([]);
    setFilterDesignations([]);
    setSearchQuery("");
  };

  const normalizedQuery = searchQuery.trim().toLowerCase();
  const filteredStaff = staffList.filter((s) => {
    if (filterTrades.length > 0 && !filterTrades.includes(s.trade)) return false;
    if (filterDesignations.length > 0 && !filterDesignations.includes((s.designation || "").trim())) return false;
    if (!normalizedQuery) return true;
    const fields = [
      s.name || "",
      s.designation || "",
      s.trade || "",
      s.email_id || "",
      s.mobile_number || "",
    ];
    return fields.some((f) => f.toLowerCase().includes(normalizedQuery));
  });

  const activeFilterCount = () => filterTrades.length + filterDesignations.length;

  if (loading) {
    return (
      <div className="staff-page">
        <div className="d-flex dashboard-container">
          <Sidebar />
          <div className="main-content flex-grow-1">
            <Header />
            <div className="container py-5 text-center">
              <div className="spinner-border text-primary" role="status">
                <span className="visually-hidden">Loading...</span>
              </div>
            </div>
            <DashboardFooter />
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="staff-page">
      <div className="d-flex dashboard-container">
        <Sidebar />
        <div className="main-content flex-grow-1">
          <Header />
          <div className="container py-5">
            <div className="d-flex justify-content-between align-items-center mb-3">
              <h3 className="fw-bold">Staff Database</h3>
              <div className="d-flex align-items-center">
                <button
                  className="btn btn-outline-secondary me-2"
                  onClick={fetchAll}
                >
                  <FaSync className="me-1" /> Refresh
                </button>
                <button className="btn btn-success me-2" onClick={exportToExcel}>
                  <FaDownload className="me-2" />
                  Export Excel
                  {filteredStaff.length !== staffList.length && (
                    <span className="badge bg-light text-dark ms-1">
                      {filteredStaff.length}
                    </span>
                  )}
                </button>
                <button
                  className="btn btn-outline-secondary me-2 d-flex align-items-center"
                  onClick={() => setShowAllColumns(!showAllColumns)}
                  title={showAllColumns ? "Show basic table" : "Show all columns"}
                >
                  <FaTable className="me-2" />
                  {showAllColumns ? "Basic View" : "Full View"}
                </button>
                <button className="btn btn-outline-primary me-2 d-flex align-items-center" onClick={openFilterModal}>
                  <FaFilter className="me-2" /> Filters
                  {activeFilterCount() > 0 && (
                    <span className="badge bg-danger ms-2">{activeFilterCount()}</span>
                  )}
                </button>

                <button className="btn btn-primary d-flex align-items-center" onClick={openAddForm}>
                  <FaPlus className="me-2" /> Add Staff
                </button>
              </div>
            </div>

            {/* 🔍 Search */}
            <div className="card mb-4 p-3">
              <div className="row g-2 align-items-center">
                <div className="col-md-6">
                  <div className="input-group">
                    <span className="input-group-text"><FaSearch /></span>
                    <input
                      type="text"
                      className="form-control"
                      placeholder="Search by name, designation, trade, email, mobile..."
                      value={searchQuery}
                      onChange={(e) => setSearchQuery(e.target.value)}
                    />
                    {searchQuery && (
                      <button className="btn btn-outline-secondary" onClick={() => setSearchQuery("")}>
                        <FaTimes />
                      </button>
                    )}
                  </div>
                </div>

                <div className="col-md-6 text-end">
                  <button
                    className="btn btn-outline-secondary"
                    onClick={() => {
                      clearAllFilters();
                    }}
                  >
                    Clear Filters
                  </button>
                </div>
              </div>
            </div>

            {/* Staff Form */}
            {showForm && (
              <form className="card shadow-lg p-4 mb-5" onSubmit={handleSubmit}>
                <h5 className="fw-bold mb-3 text-primary">
                  {editStaff ? "Edit Staff" : "Add New Staff"}
                </h5>
                <div className="row g-3">
                  <div className="col-md-4">
                    <label className="form-label">Name *</label>
                    <input
                      type="text"
                      className="form-control"
                      name="name"
                      value={formData.name}
                      onChange={handleChange}
                      required
                    />
                  </div>

                  <div className="col-md-4">
                    <label className="form-label">Designation *</label>
                    <input
                      type="text"
                      className="form-control"
                      name="designation"
                      value={formData.designation}
                      onChange={handleChange}
                      required
                    />
                  </div>

                  <div className="col-md-4">
                    <label className="form-label">Trade</label>
                    <select
                      className="form-select"
                      name="trade"
                      value={formData.trade}
                      onChange={handleChange}
                    >
                      <option value="">Select</option>
                      {tradeList.length > 0
                        ? tradeList.map((t) => (
                          <option key={t.trade_id} value={t.trade_name}>
                            {t.trade_name}
                          </option>
                        ))
                        : (
                          <>
                            <option value="Welder">Welder</option>
                            <option value="Electrician">Electrician</option>
                            <option value="Wireman">Wireman</option>
                          </>
                        )}
                    </select>
                    <div className="mt-2">
                      <small>Manage trades <Link to="/trades">here</Link>.</small>
                    </div>
                  </div>

                  <div className="col-md-4">
                    <label className="form-label">Qualification</label>
                    <input
                      type="text"
                      className="form-control"
                      name="qualification"
                      value={formData.qualification}
                      onChange={handleChange}
                    />
                  </div>

                  <div className="col-md-4">
                    <label className="form-label">Date of Joining</label>
                    <input
                      type="date"
                      className="form-control"
                      name="date_of_joining"
                      value={formData.date_of_joining}
                      onChange={handleChange}
                    />
                  </div>

                  <div className="col-md-4">
                    <label className="form-label">Date of Birth</label>
                    <input
                      type="date"
                      className="form-control"
                      name="date_of_birth"
                      value={formData.date_of_birth}
                      onChange={handleChange}
                    />
                  </div>

                  <div className="col-md-6">
                    <label className="form-label">Address</label>
                    <input
                      type="text"
                      className="form-control"
                      name="address"
                      value={formData.address}
                      onChange={handleChange}
                    />
                  </div>

                  <div className="col-md-3">
                    <label className="form-label">Blood Group</label>
                    <input
                      type="text"
                      className="form-control"
                      name="blood_group"
                      value={formData.blood_group}
                      onChange={handleChange}
                    />
                  </div>

                  <div className="col-md-3">
                    <label className="form-label">Status</label>
                    <select
                      className="form-select"
                      name="status"
                      value={formData.status}
                      onChange={handleChange}
                    >
                      <option value="active">Active</option>
                      <option value="inactive">Inactive</option>
                    </select>
                  </div>

                  <div className="col-md-3">
                    <label className="form-label">Mobile *</label>
                    <input
                      type="text"
                      className="form-control"
                      name="mobile_number"
                      value={formData.mobile_number}
                      onChange={handleChange}
                      required
                    />
                  </div>

                  <div className="col-md-4">
                    <label className="form-label">Email *</label>
                    <input
                      type="email"
                      className="form-control"
                      name="email_id"
                      value={formData.email_id}
                      onChange={handleChange}
                      required
                    />
                  </div>

                  <div className="col-md-4">
                    <label className="form-label">Staff Photo (JPG/PNG)</label>
                    <input
                      type="file"
                      className="form-control"
                      name="staff_photo"
                      onChange={handleChange}
                      accept="image/*"
                    />
                    {editStaff && editStaff.staff_photo_url && (
                      <div className="mt-2">
                        <small>Current photo:</small>
                        <div className="mt-1">
                          <img
                            src={getPhotoUrl(editStaff.staff_photo_url)}
                            alt="Current Staff"
                            className="img-thumbnail"
                            style={{ height: "80px", width: "80px", objectFit: "cover" }}
                          />
                        </div>
                      </div>
                    )}
                  </div>
                </div>

                <div className="text-center mt-4">
                  <button type="submit" className="btn btn-success px-4">
                    {editStaff ? "Update Staff" : "Save Staff"}
                  </button>
                  <button
                    type="button"
                    className="btn btn-secondary ms-2"
                    onClick={resetForm}
                  >
                    Cancel
                  </button>
                </div>
              </form>
            )}

            {/* Staff Table */}
            <div className={showAllColumns ? "table-responsive-horizontal" : "table-responsive"}>
              <table className="table table-striped table-bordered align-middle">
                <thead className="table-dark text-center">
                  <tr>
                    {tableColumns.map((col, idx) => (
                      <th key={idx}>{col.header}</th>
                    ))}
                  </tr>
                </thead>
                <tbody>
                  {filteredStaff.map((staff, i) => (
                    <tr key={staff.staff_id}>
                      {tableColumns.map((col, idx) => {
                        if (col.accessor === 'index') {
                          return <td key={idx} className="text-center">{i + 1}</td>;
                        } else if (col.accessor === 'actions') {
                          return (
                            <td key={idx} className="text-center">
                              <button className="btn btn-sm btn-info me-1" onClick={() => handleView(staff)}>
                                <FaEye />
                              </button>
                              <button className="btn btn-sm btn-warning me-1" onClick={() => handleEdit(staff)}>
                                <FaEdit />
                              </button>
                              <button className="btn btn-sm btn-danger me-1" onClick={() => handleDelete(staff.staff_id)}>
                                <FaTrash />
                              </button>
                              <button
                                className="btn btn-sm btn-primary ms-1"
                                onClick={() => handlePrintForStaff(staff)}
                                title="Print Staff Details"
                              >
                                <FaDownload />
                              </button>
                            </td>
                          );
                        } else if (col.accessor === 'staff_photo_url') {
                          return (
                            <td key={idx} className="text-center">
                              {staff.staff_photo_url && (
                                <img
                                  src={getPhotoUrl(staff.staff_photo_url)}
                                  alt="Staff"
                                  style={{ height: '40px', width: '40px', objectFit: 'cover' }}
                                  className="rounded"
                                />
                              )}
                            </td>
                          );
                        } else if (col.accessor === 'status') {
                          return (
                            <td key={idx} className="text-center">
                              <span className={`badge ${staff.status === 'active' ? 'bg-success' : 'bg-secondary'}`}>
                                {staff.status === 'active' ? 'Active' : 'Inactive'}
                              </span>
                            </td>
                          );
                        } else {
                          return <td key={idx}>{staff[col.accessor] || "—"}</td>;
                        }
                      })}
                    </tr>
                  ))}
                  {filteredStaff.length === 0 && (
                    <tr>
                      <td colSpan={tableColumns.length} className="text-center text-muted">
                        No staff records found
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>

            {/* View Modal */}
            {showViewModal && selectedStaff && (
              <div
                className="modal show d-block"
                style={{ backgroundColor: "rgba(0,0,0,0.5)" }}
                onClick={() => setShowViewModal(false)}
              >
                <div className="modal-dialog modal-lg" onClick={(e) => e.stopPropagation()}>
                  <div className="modal-content">
                    <div className="modal-header">
                      <h5 className="modal-title">Staff Details</h5>
                      <button type="button" className="btn-close" onClick={() => setShowViewModal(false)}></button>
                    </div>
                    <div className="modal-body">
                      <div className="row">
                        <div className="col-md-6">
                          <p><strong>Name:</strong> {selectedStaff.name}</p>
                          <p><strong>Designation:</strong> {selectedStaff.designation}</p>
                          <p><strong>Trade:</strong> {selectedStaff.trade}</p>
                          <p><strong>Qualification:</strong> {selectedStaff.qualification || "—"}</p>
                          <p><strong>Date of Joining:</strong> {selectedStaff.date_of_joining || "—"}</p>
                          <p><strong>Date of Birth:</strong> {selectedStaff.date_of_birth || "—"}</p>
                          <p><strong>Blood Group:</strong> {selectedStaff.blood_group || "—"}</p>
                          <p><strong>Status:</strong> <span className={`badge ${selectedStaff.status === 'active' ? 'bg-success' : 'bg-secondary'}`}>{selectedStaff.status === 'active' ? 'Active' : 'Inactive'}</span></p>
                        </div>
                        <div className="col-md-6">
                          <p><strong>Address:</strong> {selectedStaff.address}</p>
                          <p><strong>Mobile:</strong> {selectedStaff.mobile_number}</p>
                          <p><strong>Email:</strong> {selectedStaff.email_id}</p>

                          {selectedStaff.staff_photo_url && (
                            <div className="mt-3">
                              <strong><FaImage className="me-2" /> Photo:</strong>
                              <div className="mt-2">
                                <img
                                  src={getPhotoUrl(selectedStaff.staff_photo_url)}
                                  alt="Staff"
                                  className="img-fluid border rounded"
                                  style={{ maxHeight: "150px", width: "auto" }}
                                />
                              </div>
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                    <div className="modal-footer">
                      <button className="btn btn-secondary" onClick={() => setShowViewModal(false)}>
                        Close
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            )}

            {/* Filter Modal */}
            {showFilterModal && (
              <div
                className="modal show d-block"
                style={{ backgroundColor: "rgba(0,0,0,0.5)" }}
                onClick={() => setShowFilterModal(false)}
              >
                <div className="modal-dialog modal-lg" onClick={(e) => e.stopPropagation()}>
                  <div className="modal-content">
                    <div className="modal-header">
                      <h5 className="modal-title">Filters</h5>
                      <button type="button" className="btn-close" onClick={() => setShowFilterModal(false)}></button>
                    </div>
                    <div className="modal-body">
                      <div className="row">
                        {/* Trades */}
                        <div className="col-md-6 mb-3">
                          <h6>Trades</h6>
                          <div className="filter-list" style={{ maxHeight: 180, overflowY: "auto", border: "1px solid #eee", padding: 8, borderRadius: 4 }}>
                            {uniqueTrades.length === 0 ? (
                              <div className="text-muted">No trades available</div>
                            ) : (
                              uniqueTrades.map((t) => (
                                <div key={t} className="form-check">
                                  <input
                                    className="form-check-input"
                                    type="checkbox"
                                    id={`trade_${t}`}
                                    checked={tempTrades.includes(t)}
                                    onChange={() => toggleTemp(t, tempTrades, setTempTrades)}
                                  />
                                  <label className="form-check-label" htmlFor={`trade_${t}`}>{t}</label>
                                </div>
                              ))
                            )}
                          </div>
                        </div>

                        {/* Designations */}
                        <div className="col-md-6 mb-3">
                          <h6>Designations</h6>
                          <div className="filter-list" style={{ maxHeight: 180, overflowY: "auto", border: "1px solid #eee", padding: 8, borderRadius: 4 }}>
                            {uniqueDesignations.length === 0 ? (
                              <div className="text-muted">No designations available</div>
                            ) : (
                              uniqueDesignations.map((d) => (
                                <div key={d} className="form-check">
                                  <input
                                    className="form-check-input"
                                    type="checkbox"
                                    id={`desig_${d}`}
                                    checked={tempDesignations.includes(d)}
                                    onChange={() => toggleTemp(d, tempDesignations, setTempDesignations)}
                                  />
                                  <label className="form-check-label" htmlFor={`desig_${d}`}>{d}</label>
                                </div>
                              ))
                            )}
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="modal-footer">
                      <div className="w-100 d-flex justify-content-between">
                        <div>
                          <button
                            className="btn btn-outline-secondary me-2"
                            onClick={() => clearModalSelections()}
                            type="button"
                          >
                            Clear Selections
                          </button>
                          <button
                            className="btn btn-outline-danger"
                            onClick={() => {
                              clearModalSelections();
                              setFilterTrades([]);
                              setFilterDesignations([]);
                              setShowFilterModal(false);
                            }}
                            type="button"
                          >
                            Clear All Filters
                          </button>
                        </div>

                        <div>
                          <button
                            className="btn btn-secondary me-2"
                            onClick={() => setShowFilterModal(false)}
                            type="button"
                          >
                            Cancel
                          </button>
                          <button
                            className="btn btn-primary"
                            onClick={() => applyFiltersFromModal()}
                            type="button"
                          >
                            Apply Filters
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            )}

          </div>
          <DashboardFooter />
        </div>
      </div>
    </div>
  );
};

export default Staff;